import { Edit, Eye } from 'lucide-react';
import React, { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useGetAttractionsByIds, useQueryHelper } from '../../queries';
import { Action } from '../../types';
import { Table } from '..';
import { Columns } from './columns';
import { renderRows } from './rows';

interface AttractionsListProps {
  attractions: string[];
}
export const AttractionsList: FC<AttractionsListProps> = ({ attractions }) => {
  const navigate = useNavigate();

  const attractionActions : Action[] = [
    {
      label: 'Details',
      icon: <Eye size={16} color="black" />,
      onClick: (item) => navigate(`/attractions/${item.id}`),
    },
    {
      label: 'Edit',
      icon: <Edit size={16} color="black" />,
      onClick: (item) => navigate(`/attractions/${item.id}/edit`),
    },
  ];

  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get('page')) || 1;

  const attractionsArray = useGetAttractionsByIds(attractions, currentPage);
  const { data: associatedAttractions, refetch } = attractionsArray;
  const { isLoading, isError, previousData, errorMessage } = useQueryHelper({
    queries: [attractionsArray],
  });

  useEffect(() => {
    refetch();
  }, [currentPage, refetch]);

  const handlePageChange = (page: number) : void => {
    setSearchParams({ page: page.toString() });
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return (
      <div>
        Error:
        {errorMessage}
      </div>
    );
  }

  return (
    <div>
      <Table
        data-testid="attractions-table"
        isLoading={isLoading}
        onPageChange={(page) => handlePageChange(page)}
        data={associatedAttractions?.data || []}
        totalPages={previousData?.totalPages}
        currentPage={currentPage}
        rows={renderRows}
        columns={Columns}
        isError={isError}
        refetch={refetch}
        errorMessage={errorMessage}
        actions={attractionActions}
      />
    </div>
  );
};
